export default function convertFloatToPercentageString(
  value,
  withPercentCharacter = true
) {
  const numberValue = parseFloat(value);

  if (Number.isNaN(numberValue)) {
    return '';
  }

  // Multiply by 100 to convert to percentage
  const percentage = numberValue * 100;

  // Check if the number is a whole number
  if (Number.isInteger(percentage)) {
    // For whole numbers, add .0 to the string
    return withPercentCharacter ? `${percentage}.0%` : `${percentage}.0`;
  }

  const roundedPercentage = +parseFloat(Number(percentage).toPrecision(15));

  return withPercentCharacter
    ? `${roundedPercentage}%`
    : `${roundedPercentage}`;
}
